export default "__VITE_ASSET__50fcd30d__"